import {Image, Input, Upload} from 'antd'
import {image_upload_Api} from 'apis'
import {getBase64} from 'components/form/fields/ImageUpload'
import FieldsFactory from 'components/form/FieldsFactory'
import {StepsForm} from 'components/form/StepsForm'
import {createValue} from 'components/form/utils'
import Pure from 'components/Pure'
import {API_ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import {callApi} from 'modules/asyncCache/callApi'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React from 'react'
import {PiPlusBold, PiTrash} from "react-icons/pi";
import {NullAsDefault} from 'views/Shared'
import {HeaderWithIconLine} from "../AppLocals/Templates/items/ListHeader";
import Translate from "../../modules/local/Translate";
import {HiViewfinderCircle} from "react-icons/hi2";
import {notifyOnError} from "../AppLocals/factory/createErrorEvent";

export function getUploadedPhotos(photos = []) {
    return photos.map(({id, path, ...photo}) => {
        return {
            id,
            uid: id,
            name: path,
            status: 'done',
            url: path,
        }
    })
}


export const PicturesWall = withTranslate(
    class extends React.PureComponent {
        state = {
            previewImage: '',
            previewVisible: false,
            fileList: this.props.values?.fileList || [],
        }

        handleCancel = () => this.setState({previewVisible: false})

        handlePreview = async (file) => {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj)
            }

            this.setState({
                previewImage: file.url || file.preview,
                previewVisible: true,
            })
        }

        handleChange = ({file, fileList}) => {
            this.setState({fileList})
            if (file.status !== 'uploading') {
                const {onChange = NullAsDefault} = this.props
                onChange(createValue('fileList', fileList))
                onChange(
                    createValue(
                        'photos',
                        fileList.map((info) => _.get(info, 'response.data.ids.0', info.id))
                    )
                )
            }
        }

        render() {
            const {translate: t} = this.props
            const {previewVisible, previewImage, fileList} = this.state
            const uploadButton = (
                <div className="flex flex-col gap-1 items-center">
                    <PiPlusBold size={15} className="text-color-400"/>
                    <div className="ant-upload-text text-xs font-medium text-color-300">
                        {t('upload')}
                    </div>
                </div>
            )

            return (
                <div className="w-full mt-3">
                    <div className="flex flex-col gap-2">
                        <span className="font-medium text-xs text-color-400 tracking-wider uppercase">
                            {t('add photo')}
                        </span>
                        <Upload
                            multiple
                            accept=".jpg,.jpeg,.png,.webp"
                            listType="picture-card"
                            customRequest={({onSuccess, ...args}) => {
                                callApi({
                                    apiInfo: image_upload_Api,
                                    values: {
                                        'photos[]': args.file,
                                    },
                                })
                                    .then((res) => {
                                        console.log("✅ API response:", res);
                                        if (res.error) {
                                            notifyOnError(t)(res.error, res.errorMessages)
                                        } else {
                                            onSuccess(res);
                                        }
                                    })
                                    .catch((err) => {
                                        console.error("❌ API error:", err);
                                    });
                            }}
                            action={`${API_ROOT_URL}/images/image/upload`}
                            onChange={this.handleChange}
                            onPreview={this.handlePreview}
                            fileList={fileList}
                            itemRender={(component, file, files, actions) => {
                                return (
                                    <div className="h-full custom-img-attached relative">
                                        <Image
                                            src={file.thumbUrl || file.url}
                                            className="rounded-md"
                                            wrapperClassName="h-full rounded-md"
                                            style={{width: '100%', height: '100%', objectFit: 'none'}}
                                            preview={{
                                                mask: (
                                                    <div className="p-1 absolute right-0 bottom-0">
                                                        <div className="flex gap-3">
                                                            <HiViewfinderCircle
                                                                size={16}
                                                                onClick={actions.preview}
                                                                className="text-white opacity-75 hover:opacity-100 cursor-pointer"
                                                            />
                                                            <PiTrash
                                                                size={16}
                                                                onClick={actions.remove}
                                                                className="text-white hover:text-primary-500 opacity-75 hover:opacity-100 cursor-pointer"
                                                            />
                                                        </div>
                                                    </div>
                                                ),
                                            }}
                                        />
                                    </div>
                                )
                            }}>
                            {fileList.length >= 16 ? null : uploadButton}
                        </Upload>
                    </div>
                </div>
            )
        }
    }
)

const MessageForm = () => {
    const translate = useTranslate()
    return (
        <Pure>
            <FieldsFactory
                formSchema={[
                    {
                        children: {
                            type: 'message',
                            name: 'description',
                            label: translate('your message'),
                            component: Input.TextArea,
                            withProps: {
                                autosize: {
                                    minRows: 4,
                                    maxRows: 12,
                                },
                                type: 'text',
                                size: 'large',
                                placeholder: translate('Write your sharing'),
                            },
                        },
                    },
                ]}
            />
        </Pure>
    )
}

export const CreateImagePostRoutes = [
    {
        path: '/questtionAndAnswers',
        name: 'post your images',
        component: PicturesWall,
        exact: true,
    },
    {
        path: '/message',
        name: 'post your images',
        component: MessageForm,
        exact: true,
    },
]

export default function CreateImagePost({handleAsyncPost, isLoading}) {
    return (
        <Translate>
            {(t) => (
                <div className="flex flex-col gap-3">
                    <div className="text-center font-bold text-color-000 uppercase tracking-wider">
                        {t('post image')}
                    </div>
                    <StepsForm
                        isLoading={isLoading}
                        routes={CreateImagePostRoutes}
                        initialValues={{
                            description: '',
                            photos: [],
                        }}
                        onSubmit={(values) => {
                            const {fileList, ...rest} = values ?? {}
                            handleAsyncPost(rest)
                        }}
                    />
                </div>
            )}
        </Translate>
    )
}
